import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {order,iStatusOperation} from '../../services/api/api'
// Models

interface iOrder {[key:string]:order[]}

// Orders state
export interface ordersState {
    isLoaded: boolean, // First load
    isLoading: boolean, // On filtering laoder
    isFetching: boolean,
    hasMore: boolean,
    orders:iOrder,
    page:number,
    operationsStatus:iStatusOperation[],
    filteredOrders:iOrder
}

const initialOrdersState: ordersState = {
    isLoaded: false,
    isLoading: false,
    isFetching: false,
    hasMore: true,
    orders: {},
    filteredOrders:{},
    page:1,
    operationsStatus:[]
}

// Orders slice
export const ordersSlice = createSlice({
    name: 'orders',
    initialState: initialOrdersState,
    reducers: {
        setIsLoaded: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoaded = payload
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsFetching: (state, { payload }: PayloadAction<boolean>) => {
            state.isFetching = payload
        },
        setHasMore: (state, { payload }: PayloadAction<boolean>) => {
            state.hasMore = payload
        },
        initializeOrders: (state, { payload }: PayloadAction<order[]>) => {
    
            state.orders[state.page] = [...payload]
        },
        addOrders: (state, { payload }: PayloadAction<order[]>) => {
    
            state.orders[state.page] =   state.orders[state.page]?
             [...state.orders[state.page], ...payload]:[...payload]
        },
        updateOrder: (state, { payload }: PayloadAction<order>) => {
             let store = state.filteredOrders[state.page]?state.filteredOrders[state.page]:state.orders[state.page]
            let index = store.findIndex(order => order.id === payload.id)
            if (index !== -1)
               store[index] = payload
        },
        // setIsLoadingOrder: (state, { payload }: PayloadAction<{ id: number, isLoading: boolean }>) => {
        //     let index = state.orders[state.page]
        //     .findIndex(order => order.id === payload.id)
        //     if (index !== -1)
        //         state.orders[state.page][index].isLoading = payload.isLoading
        // },
        deleteOrders: (state, { payload }: PayloadAction<number[]>) => {
            payload.map(id => {
                let store = state.filteredOrders[state.page]?state.filteredOrders[state.page]:state.orders[state.page]
                let index = store.findIndex(order => order.id === id)
                if (index != -1)
                    store.splice(index, 1)
            })
      
        },
        reset: (state) => {
            state.orders = {}
            state.hasMore = true
        },
        updateInvoiceIssued:(state,{payload}:PayloadAction<{ id: number, invoice_issued: boolean }>)=>{
            let store = state.filteredOrders[state.page]?state.filteredOrders[state.page]:state.orders[state.page]
            let index =store.findIndex(order => order.id === payload.id)
        
            if (index !== -1) store[index].invoice_issued=payload.invoice_issued
         },
         updateDeliveryOrderIssued:(state,{payload}:PayloadAction<{ id: number, delivery_order_issued: boolean }>)=>{
             let store = state.filteredOrders[state.page]?state.filteredOrders[state.page]:state.orders[state.page]
            let index = store.findIndex(order => order.id === payload.id)
            if (index !== -1) store[index].delivery_order_issued=payload.delivery_order_issued
         },
         updateJobOrderPrinted:(state,{payload}:PayloadAction<{id:number,job_order_printed:boolean}>)=>{
              let store = state.filteredOrders[state.page]?state.filteredOrders[state.page]:state.orders[state.page]
            let index = store.findIndex(order => order.id === payload.id)
            if (index !== -1) store[index].job_order_printed=payload.job_order_printed
         },
         setPage:(state,{payload}:PayloadAction<number>)=>{
            state.page=payload
        },
        setStatusOperations :(state,{payload}:PayloadAction<iStatusOperation[]>)=>{
            state.operationsStatus=[...payload.slice(0,13)

        ]
        },
        filterOrders :(state,{payload}:PayloadAction <order[]>)=>{
             state.filteredOrders[state.page] = [...payload]
        },
        resetFilter:(state)=>{
            state.filteredOrders={}
        }
    }
})